import React from 'react'
import TaskFeature from '../../features/TaskFeature'
import PageHeader from '../../components/PageHeader'
import PAGE_TITLES from '../../consts/titles'
import CustomHeader from '../../components/CustomHeader'
import { Box } from '@mui/material'

const TaskPage = (): JSX.Element => {
  return (
    <Box display='flex' flexDirection='column' gap={6}>
      <CustomHeader title={PAGE_TITLES.TASKS} />
      <PageHeader title={PAGE_TITLES.TASKS} />
      <TaskFeature />
    </Box>
  )
}

export default TaskPage
